import "./styles/index.css"

import type { Content, Editor } from "@tiptap/react"
import type { UseMinimalTiptapEditorProps } from "./hooks/use-minimal-tiptap"
import { EditorContent } from "@tiptap/react"
import { Separator } from "@/components/ui/separator"
import { cn } from "@/lib/utils"
import { SectionTwo } from "./components/section/two"
import { SectionFour } from "./components/section/four"
import { LinkBubbleMenu } from "./components/bubble-menu/link-bubble-menu"
import { useMinimalTiptapEditor } from "./hooks/use-minimal-tiptap"
import { MeasuredContainer } from "./components/measured-container"
import {ReactElement} from "react";

export interface MinimalTiptapProps
  extends Omit<UseMinimalTiptapEditorProps, "onUpdate"> {
  value?: Content
  onChange?: (value: Content) => void
  className?: string
  editorContentClassName?: string,
  toolbar?: ReactElement[]
  disabled?: boolean
}

const Toolbar = ({ editor, children }: { editor: Editor, children?: ReactElement[] }) => (
  <div className="border-border flex shrink-0 overflow-x-auto border-b p-1">
    <div className="flex w-max items-center gap-px">
      {/*<SectionOne editor={editor} activeLevels={[1, 2, 3, 4, 5, 6]} />

      <Separator orientation="vertical" className="mx-2" />*/}

      <SectionTwo
        editor={editor}
        activeActions={[
          "bold",
          "italic",
          "underline", /*
          "strikethrough",
          "code",
          "clearFormatting",*/
        ]}
        mainActionCount={3}
      />

      {/*<Separator orientation="vertical" className="mx-2" />

      <SectionThree editor={editor} />*/}

      <Separator orientation="vertical" className="mx-2" />

      <SectionFour
        editor={editor}
        activeActions={["orderedList", "bulletList"]}
        mainActionCount={0}
      />
      {children}

      {/*
      <Separator orientation="vertical" className="mx-2" />

      <SectionFive
        editor={editor}
        activeActions={["codeBlock", "blockquote", "horizontalRule"]}
        mainActionCount={0}
      />
      */}
    </div>
  </div>
)

export const MinimalTiptapEditor = ({
  value,
  onChange,
  className,
  editorContentClassName,
  ...props
}: MinimalTiptapProps) => {
  const editor = useMinimalTiptapEditor({
    value,
    onUpdate: onChange,
    ...props,
  })

  if (!editor) {
    return null
  }

  return (
    <MeasuredContainer
      as="div"
      name="editor"
      className={cn(
        "border-input focus-within:border-primary min-data-[orientation=vertical]:h-72 flex h-auto w-full flex-col rounded-md border shadow-xs bg-white",
        className
      )}
    >
      <Toolbar editor={editor} >{props.toolbar}</Toolbar>
      <EditorContent
        editor={editor}
        disabled={props.disabled}
        className={cn("minimal-tiptap-editor", editorContentClassName)}
      />
      <LinkBubbleMenu editor={editor} />
    </MeasuredContainer>
  )
}

MinimalTiptapEditor.displayName = "MinimalTiptapEditor"

export default MinimalTiptapEditor
